import 'virtual:svg-icons-register'

import { addCollection } from '@iconify/vue'
import epIcons from '@iconify/json/json/ep.json'
import faIcons from '@iconify/json/json/fa.json'
import faSolidIcons from '@iconify/json/json/fa-solid.json'
import offlineIconCollections from './offline-icons.json'

addCollection(epIcons)
addCollection(faIcons)
addCollection(faSolidIcons)

// 注册项目实际使用的其他 Iconify 集合，避免生产环境依赖外网加载。
offlineIconCollections.forEach((collection) => addCollection(collection))
